export default __webpack_public_path__ + "static/media/hand-with-chocolate.eb8e02a3.png";